import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CalendlyConnectionResponse } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

const KEY = ['calendly-connections'];

export function useCalendlyConnectionsQuery() {
  return useQuery({ queryKey: KEY, queryFn: () => api.get<CalendlyConnectionResponse[]>('/calendly/connections') });
}

export function useDisconnectCalendly() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<void>(`/calendly/connections/${id}/disconnect`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useReactivateCalendly() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post<CalendlyConnectionResponse>(`/calendly/connections/${id}/reactivate`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

/** Full-page OAuth redirect, not an API call — same reasoning
 * `pulseConnectUrl`/`mailboxConnectUrl` use theirs. */
export const calendlyConnectUrl = '/api/v1/calendly/start';
